/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TrainingSessionCreateRequest
 */
export interface TrainingSessionCreateRequest {
    /**
     * 
     * @type {Date}
     * @memberof TrainingSessionCreateRequest
     */
    sessionDate: Date;
    /**
     * 
     * @type {string}
     * @memberof TrainingSessionCreateRequest
     */
    startTime: string;
    /**
     * 
     * @type {string}
     * @memberof TrainingSessionCreateRequest
     */
    endTime: string;
    /**
     * 
     * @type {number}
     * @memberof TrainingSessionCreateRequest
     */
    sessionExtraFee?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrainingSessionCreateRequest
     */
    notes?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrainingSessionCreateRequest
     */
    publicNotes?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrainingSessionCreateRequest
     */
    privateNotes?: string | null;
}

/**
 * Check if a given object implements the TrainingSessionCreateRequest interface.
 */
export function instanceOfTrainingSessionCreateRequest(value: object): value is TrainingSessionCreateRequest {
    if (!('sessionDate' in value) || value['sessionDate'] === undefined) return false;
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    if (!('endTime' in value) || value['endTime'] === undefined) return false;
    return true;
}

export function TrainingSessionCreateRequestFromJSON(json: any): TrainingSessionCreateRequest {
    return TrainingSessionCreateRequestFromJSONTyped(json, false);
}

export function TrainingSessionCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrainingSessionCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'sessionDate': (new Date(json['sessionDate'])),
        'startTime': json['startTime'],
        'endTime': json['endTime'],
        'sessionExtraFee': json['sessionExtraFee'] == null ? undefined : json['sessionExtraFee'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'publicNotes': json['publicNotes'] == null ? undefined : json['publicNotes'],
        'privateNotes': json['privateNotes'] == null ? undefined : json['privateNotes'],
    };
}

export function TrainingSessionCreateRequestToJSON(json: any): TrainingSessionCreateRequest {
    return TrainingSessionCreateRequestToJSONTyped(json, false);
}

export function TrainingSessionCreateRequestToJSONTyped(value?: TrainingSessionCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sessionDate': value['sessionDate'].toISOString().substring(0,10),
        'startTime': value['startTime'],
        'endTime': value['endTime'],
        'sessionExtraFee': value['sessionExtraFee'],
        'notes': value['notes'],
        'publicNotes': value['publicNotes'],
        'privateNotes': value['privateNotes'],
    };
}

